module.exports = __webpack_public_path__ + "media/images/accord-majeur-hover-bf84f0ebb5052adae668dc1e79b50e28.png";